//region :: Imports ::
import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import PrimeReact from 'primereact/api';
import App from './App';
import './App.scss';
import LogoutPage from './Toolkit/Pages/LogoutPage';
import AITelemetryProvider from './Toolkit/Components/Logging/AITelemetryProvider';
import Environment from './Toolkit/Environment';
import ListSafeDigsPage from './SafeDigs/ListSafeDigsPage';
import CreateSafeDigPage from './SafeDigs/CreateSafeDigPage';
import EditSafeDigPage from './SafeDigs/EditSafeDigPage';
import AccessDeniedPage from './Toolkit/Pages/AccessDeniedPage';
import MAppContainer from './Toolkit/Components/Shell/AppContainer';
import CreateNoticePage from './SafeDigs/CreateNoticePage';
import EditNoticePage from './SafeDigs/EditNoticePage';
import ListNoticesPage from './SafeDigs/ListNoticesPage';
import CreateRegistrationPage from './SafeDigs/CreateRegistrationPage';
import EditRegistrationPage from './SafeDigs/EditRegistrationPage';
import CreateContactPage from './SafeDigs/CreateContactPage';
import ListContactsPage from './SafeDigs/ListContactsPage';
import EditContactPage from './SafeDigs/EditContactPage';
import ListRegistrationsPage from './SafeDigs/ListRegistrationsPage';
import EditNoticeDetailPage from './SafeDigs/EditNoticeDetailPage';

//endregion

//  PrimeReact
PrimeReact.ripple = true;
PrimeReact.cssTransition = true;

//  Routes
let routes =
    <Routes>
        <Route path="/" element={<MAppContainer/>}>
            <Route path="" element={<App/>}>
                <Route index element={<ListSafeDigsPage />} />
                <Route path="safedigs" element={<ListSafeDigsPage />} />
                <Route path="safedigs/create/:safedigId?/:subCount?" element={<CreateSafeDigPage />} />
                <Route path="safedigs/:id" element={<EditSafeDigPage />} />
                <Route path="notices" element={<ListNoticesPage />} />
                <Route path="notices/create/:sourceType/:sourceId/:param1" element={<CreateNoticePage />} />
                <Route path="notices/:id" element={<EditNoticePage />} />
                <Route path="notices/detail/:id" element={<EditNoticeDetailPage />} />
                <Route path="registrations/create" element={<CreateRegistrationPage />} />
                <Route path="registrations/create/:noticeid" element={<CreateRegistrationPage />} />
                <Route path="registrations/:id" element={<EditRegistrationPage />} />
                <Route path="registrations" element={<ListRegistrationsPage />} />
                <Route path="contacts" element={<ListContactsPage />} />
                <Route path="contacts/create" element={<CreateContactPage />} />
                <Route path="contacts/:id" element={<EditContactPage />} />
            </Route>
            <Route path="access-denied" element={<AccessDeniedPage/>}/>
            <Route path="logout" element={<LogoutPage/>}/>
        </Route>
    </Routes>;

if(!Environment.isLocal && !Environment.isDevelopment) {
    routes = (
        <AITelemetryProvider connectionString={process.env.REACT_APP_APPINSIGHTS_CONNECTIONSTRING!}>
            {routes}
        </AITelemetryProvider>
    );
}

//  React 18 Render
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            {routes}
        </BrowserRouter>
    </React.StrictMode>
);

//  If you want to start measuring performance in your app, pass a function
//  to log results (for example: reportWebVitals(console.log))
//  or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
